export { RegularCopyAlt } from "./RegularCopyAlt";
